// extracted by mini-css-extract-plugin
export var aircallIframe = "_mr-3";
export var fabContainer = "_mr-5";
export var fabRinging = "_mr-6";
export var loadingOverlay = "_mr-4";
export var pulse = "_mr-7";
export var widgetContent = "_mr-2";
export var widgetPanel = "_mr-0";
export var widgetPanelExpanded = "_mr-1";